import Vue from 'vue'
import Vuex from 'vuex'

//All modules
import home from './modules/home'
import user from './modules/user'
import question from './modules/question'
import quiz_response from './modules/quiz_response'

//For administrator only
import subject from './modules/subject'
import grade from './modules/grade'
import grade_subject from './modules/grade_subject'
import category from './modules/category'
import skill from './modules/skill'
import clipart from './modules/clipart'
import picture_library from './modules/picture_library'
import kid from './modules/kid'
import analytics from './modules/analytics'
import question_response from './modules/question_response'
import quiz from './modules/quiz'
import school from './modules/school'
import classroom from './modules/classroom'
import section from './modules/section'
import badge from './modules/badge'
Vue.use(Vuex)

export default new Vuex.Store({
	modules : {home, user, question, quiz_response,  clipart, subject, grade, grade_subject, category, skill, kid, analytics, picture_library, question_response, quiz, school, classroom, section, badge }
})